import { create } from 'zustand';
import { mountStoreDevtool } from 'simple-zustand-devtools';

const useResumeSettingsStore = create()((set) => ({
  resumeSettings: {},
  setResumeSettings: (resumeSettings) => set((oldState) => ({
    ...oldState,
    resumeSettings: { ...oldState.resumeSettings, ...resumeSettings }
  }))
}));
mountStoreDevtool("ResumeSettingsStore", useResumeSettingsStore);
const RESET_RESUME_SETTING = {
  rawText: "",
  summarizedText: "",
  jobTitle: "",
  resumeTitle: "",
  companyName: "",
  jobDescription: "",
  targetJobTitle: "",
  uploadSource: "",
  affindaData: "",
  receivedAffindaParsedData: false,
  selectedResume: "",
  isCustomResumeTitle: false,
  resumeSkillScore: 0,
  prevJobId: "",
  prevJobTitle: ""
};

export { RESET_RESUME_SETTING, useResumeSettingsStore };
